import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EditMyTicketTab = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [referenceNumber, setReferenceNumber] = useState("");
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!name || !referenceNumber) {
            toast.error(t("pleaseFillAllFields"));
            return;
        }
        navigate(`/edit-ticket?pnr=${referenceNumber}&name=${name}`);
    };
    return (
        <form
            onSubmit={handleSubmit}
            className=" flex flex-col md:flex-row gap-3 "
        >
            <div className="flight_Search_boxed flex-1">
                <p>{t("lastName")}</p>
                <input
                    type="text"
                    className="h-10"
                    value={name}
                    onChange={(e)=> setName(e.target.value) }
                    placeholder={t("enterYourLastname")}
                />
            </div>
            <div className="flight_Search_boxed flex-1">
                <p>{t("reference")}</p>
                <input
                    type="text"
                    className="h-10"
                    value={referenceNumber}
                    placeholder={t("enterYourReference")}
                    onChange={(e)=> setReferenceNumber(e.target.value) }
                />
            </div>
            <div className="">
                <Button type="submit" className="bg-primary h-fit w-full md:h-[85px]">
                    <i className="fas fa-search"></i> {t("search")}
                </Button>
            </div>
        </form>
    );
};

export default EditMyTicketTab;
